var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoTc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 320.861,
    height: 484,
    viewBox: "0 0 320.861 484",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_25",
    x: 53.678,
    y: 89.797,
    width: 106.282,
    height: 313.133,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.765
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_26",
    x: 144.952,
    y: 105.04,
    width: 109.077,
    height: 297.889,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.765
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_27",
    x: 0,
    y: 36.911,
    width: 272.549,
    height: 447.089,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.765
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_28",
    x: 69.289,
    y: 12.771,
    width: 32.449,
    height: 37.127,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.765
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_29",
    x: 97.113,
    y: 4.191,
    width: 33.868,
    height: 38.04,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.765
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_30",
    x: 124.954,
    y: 0.634,
    width: 32.766,
    height: 35.67,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.765
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_31",
    x: 152.759,
    y: 0,
    width: 31.203,
    height: 36.293,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.765
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_32",
    x: 179.569,
    y: 5.776,
    width: 35.814,
    height: 35.817,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-8"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.765
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_27",
    x: 207.364,
    y: 15.697,
    width: 25.669,
    height: 33.836,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-9"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.765
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_33",
    x: 219.9,
    y: 23.812,
    width: 36.251,
    height: 40.495,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-10"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.765
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-10"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_34",
    x: 242.473,
    y: 43.714,
    width: 35.124,
    height: 35.221,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-11"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.765
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-11"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_35",
    x: 268.88,
    y: 80.092,
    width: 35.859,
    height: 35.558,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-12"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.765
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-12"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_36",
    x: 280.38,
    y: 110.11,
    width: 35.804,
    height: 35.804,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-13"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.765
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-13"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_37",
    x: 285.17,
    y: 143.123,
    width: 35.691,
    height: 32.762,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-14"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.765
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-14"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_38",
    x: 285.638,
    y: 173.654,
    width: 34.982,
    height: 28.634,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-15"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.765
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-15"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_28",
    x: 285.638,
    y: 198.588,
    width: 34.982,
    height: 17.086,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-16"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.765
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-16"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_39",
    x: 285.638,
    y: 213.613,
    width: 34.984,
    height: 32.453,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-17"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.765
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-17"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_40",
    x: 285.638,
    y: 243.06,
    width: 34.984,
    height: 28.868,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-18"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.765
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-18"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_41",
    x: 285.638,
    y: 268.986,
    width: 34.982,
    height: 31.926,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-19"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.765
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-19"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_42",
    x: 285.638,
    y: 296.757,
    width: 34.984,
    height: 31.959,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-20"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.765
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-20"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_29",
    x: 285.526,
    y: 324.217,
    width: 35.05,
    height: 17.727,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-21"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.765
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-21"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_43",
    x: 282.237,
    y: 338.558,
    width: 37.087,
    height: 32.133,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-22"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.765
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-22"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_44",
    x: 274.657,
    y: 362.865,
    width: 38.293,
    height: 28.053,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-23"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.765
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-23"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_45",
    x: 264.939,
    y: 385.861,
    width: 35.856,
    height: 34.047,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-24"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.765
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-24"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(4.5 2.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -4.5, -2.5)",
    filter: "url(#Path_25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25-2",
    "data-name": "Path 25",
    d: "M80.89,70.332c0,23.435-23.765,23.435-23.765,23.435s-23.436,0-23.436,23.766c0-47.2,47.2-47.2,47.2-47.2m44.081-13.974a48.052,48.052,0,0,1-23.438,41.921V354.491H78.1V103.56c0-23.768,23.436-23.768,23.436-23.768s23.438,0,23.438-23.435",
    transform: "translate(24.49 35.94)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -4.5, -2.5)",
    filter: "url(#Path_26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26-2",
    "data-name": "Path 26",
    d: "M138.176,348.814c-47.2,0-47.2-47.2-47.2-47.2V113.127s0-47.2,47.2-47.2c-23.766,0-23.766,23.435-23.766,23.435V325.377s0,23.438,23.766,23.438m0-282.889c46.874,0,46.874,47.2,46.874,47.2-23.438,0-23.438-23.768-23.438-23.768s0-23.435-23.436-23.435m46.874,235.686s0,47.2-46.874,47.2c23.436,0,23.436-23.438,23.436-23.438s0-23.766,23.438-23.766",
    transform: "translate(58.48 41.62)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -4.5, -2.5)",
    filter: "url(#Path_27)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27-2",
    "data-name": "Path 27",
    d: "M252.368,398.5A138.491,138.491,0,0,1,147.286,446.77c-76.537,0-138.8-62.267-138.8-138.8V139.825A138.617,138.617,0,0,1,62.436,30.091l-4.907-6.925A147.094,147.094,0,0,0,0,139.825V307.969c0,81.215,66.072,147.286,147.286,147.286a146.94,146.94,0,0,0,110.263-49.79Z",
    transform: "translate(4.5 16.25)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -4.5, -2.5)",
    filter: "url(#Path_28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28-2",
    "data-name": "Path 28",
    d: "M52.857,13.049,60.935,29.21l-1.864.932L50.988,13.981,44.341,17.3,43.487,15.6,58.649,8.015l.857,1.71Z",
    transform: "translate(30.3 7.26)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -4.5, -2.5)",
    filter: "url(#Path_29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29-2",
    "data-name": "Path 29",
    d: "M65.473,14.622l10.191-2.944.539,1.861L66.012,16.485l1.96,6.772,11.316-3.27.531,1.834L66.5,25.67,60.95,6.48,74.272,2.63,74.8,4.464,63.485,7.736Z",
    transform: "translate(40.66 4.06)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -4.5, -2.5)",
    filter: "url(#Path_30)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30-2",
    "data-name": "Path 30",
    d: "M81.737,13.639l.7,7.227-2.076.2L78.423,1.175l7.4-.722c4.449-.433,7.815,1.691,8.2,5.612.314,3.247-1.662,5.714-4.935,6.681l7.1,6.781-2.605.255-6.906-6.623Zm5.078-2.412c3.247-.317,5.4-2.21,5.129-4.958-.269-2.779-2.744-4.222-5.991-3.907l-5.264.511.862,8.865Z",
    transform: "translate(51.03 2.74)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -4.5, -2.5)",
    filter: "url(#Path_31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31-2",
    "data-name": "Path 31",
    d: "M98.591,12.852l-.642,7.226-2.075-.183L97.633,0l7.4.655c4.445.394,7.361,3.1,7.014,7.019-.287,3.247-2.68,5.306-6.072,5.655l5.723,7.965-2.605-.229-5.562-7.775Zm5.435-1.436c3.247.288,5.7-1.176,5.948-3.928.245-2.777-1.917-4.649-5.166-4.938l-5.264-.465-.787,8.865Z",
    transform: "translate(61.38 2.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -4.5, -2.5)",
    filter: "url(#Path_32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32-2",
    "data-name": "Path 32",
    d: "M133.072,17.015a10.4,10.4,0,1,1-6.988-12.949,10.385,10.385,0,0,1,6.988,12.949m-2.025-.609a8.3,8.3,0,1,0-15.9-4.753,8.3,8.3,0,1,0,15.9,4.753",
    transform: "translate(71.37 4.65)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -4.5, -2.5)",
    filter: "url(#Rectangle_27)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27-2",
    "data-name": "Rectangle 27",
    width: 19.961,
    height: 2.084,
    transform: "translate(211.86 36.11) rotate(-63.85)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -4.5, -2.5)",
    filter: "url(#Path_33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33-2",
    "data-name": "Path 33",
    d: "M143.857,26.613l-4.127,5.977-1.718-1.184,11.354-16.461,6.126,4.224c3.677,2.54,4.884,6.335,2.642,9.579-1.851,2.686-4.954,3.3-8.081,1.926l1.053,9.766-2.154-1.487-1.007-9.52Zm5.443,1.431c2.685,1.853,5.551,1.794,7.121-.483,1.587-2.3.626-5-2.063-6.851L150,17.7l-5.057,7.334Z",
    transform: "translate(86.39 11.37)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -4.5, -2.5)",
    filter: "url(#Path_34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34-2",
    "data-name": "Path 34",
    d: "M170.9,39.659l-1.45-1.458c1.4-2.052,1.284-4.421-1.1-6.818-2.133-2.148-4.586-2.53-6.23-.894-1.292,1.284-1.048,3.113.481,5.322l1.719,2.559c2,2.98,2.245,5.6.223,7.607-2.584,2.568-6.383,2.162-9.531-1.007-3.376-3.4-3.762-7.325-1.028-10.7l1.45,1.458c-1.859,2.551-1.616,5.377.974,7.983,2.237,2.25,4.767,2.591,6.458.915,1.189-1.181,1.276-2.886-.236-5.072l-1.965-2.937c-2.108-3.082-2.1-5.7-.182-7.6,2.436-2.423,6.072-2.016,9.076,1.007,2.838,2.854,3.783,6.514,1.338,9.643",
    transform: "translate(94.79 18.78)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -4.5, -2.5)",
    filter: "url(#Path_35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35-2",
    "data-name": "Path 35",
    d: "M179.928,68.566l.986,1.906a9.321,9.321,0,0,1-10.97-5,10.4,10.4,0,0,1,18.467-9.576,9.314,9.314,0,0,1-2.227,11.846l-.986-1.9a7.18,7.18,0,0,0,1.442-9.023,8.4,8.4,0,0,0-14.922,7.737,7.178,7.178,0,0,0,8.21,4.018",
    transform: "translate(104.63 32.33)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -4.5, -2.5)",
    filter: "url(#Path_36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36-2",
    "data-name": "Path 36",
    d: "M189.008,89.567a10.4,10.4,0,1,1,7.423-12.692,10.376,10.376,0,0,1-7.423,12.692m-.534-2.044a8.3,8.3,0,1,0-10.285-5.87,8.351,8.351,0,0,0,10.285,5.87",
    transform: "translate(108.91 43.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -4.5, -2.5)",
    filter: "url(#Path_37)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37-2",
    "data-name": "Path 37",
    d: "M179.69,107.589l-.078-1.791,15.645-13.727-16.188.677-.091-2.086,19.982-.837.072,1.7-15.846,13.821,16.4-.685.088,2.086Z",
    transform: "translate(110.69 55.8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -4.5, -2.5)",
    filter: "url(#Path_38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38-2",
    "data-name": "Path 38",
    d: "M189.672,111.074v10.285h-1.939V111.074h-8.462v-2.086h19.982v13.634h-1.909V111.074Z",
    transform: "translate(110.87 67.17)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -4.5, -2.5)",
    filter: "url(#Rectangle_28)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28-2",
    "data-name": "Rectangle 28",
    width: 19.982,
    height: 2.086,
    transform: "translate(290.14 201.09)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -4.5, -2.5)",
    filter: "url(#Path_39)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39-2",
    "data-name": "Path 39",
    d: "M199.255,141c0,6.173-4.084,10.519-9.847,10.519-5.965,0-10.137-4.347-10.137-10.519v-6.934h19.984Zm-18.073,0a7.971,7.971,0,0,0,8.226,8.376c4.614,0,7.936-3.467,7.936-8.376v-4.848H181.181Z",
    transform: "translate(110.87 82.05)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -4.5, -2.5)",
    filter: "url(#Path_40)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40-2",
    "data-name": "Path 40",
    d: "M190.174,154.634v10.61h-1.939v-10.61h-7.054v11.783h-1.91V152.548h19.984v13.868h-1.91V154.634Z",
    transform: "translate(110.87 93.01)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -4.5, -2.5)",
    filter: "url(#Path_41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41-2",
    "data-name": "Path 41",
    d: "M179.271,185.746v-1.794L195.464,170.9H179.271V168.82h19.982v1.7l-16.4,13.135h16.4v2.087Z",
    transform: "translate(110.87 102.67)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -4.5, -2.5)",
    filter: "url(#Path_42)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42-2",
    "data-name": "Path 42",
    d: "M197.344,195.773H179.271v-2.087h18.073v-7.436h1.91v16.959h-1.91Z",
    transform: "translate(110.87 113.01)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -4.5, -2.5)",
    filter: "url(#Rectangle_29)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29-2",
    "data-name": "Rectangle 29",
    width: 2.087,
    height: 19.993,
    transform: "matrix(0.03, -1, 1, 0.03, 290.03, 328.8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -4.5, -2.5)",
    filter: "url(#Path_43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43-2",
    "data-name": "Path 43",
    d: "M189.92,216.436l-1.848,10.443-1.909-.339L188.01,216.1l-6.942-1.227-2.051,11.6-1.88-.335,2.411-13.653,19.676,3.475-2.415,13.658-1.88-.331,2.051-11.6Z",
    transform: "translate(109.6 128.57)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -4.5, -2.5)",
    filter: "url(#Path_44)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44-2",
    "data-name": "Path 44",
    d: "M172.379,240.146l4.544-12.406,18.749,6.862-.717,1.96-16.983-6.222-3.827,10.452Z",
    transform: "translate(106.78 137.63)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -4.5, -2.5)",
    filter: "url(#Path_45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45-2",
    "data-name": "Path 45",
    d: "M176.855,260.662l1.036-1.773c2.344.825,4.606.1,6.308-2.817,1.53-2.613,1.268-5.078-.736-6.251-1.574-.919-3.281-.215-5.021,1.831l-2.035,2.32c-2.361,2.7-4.829,3.609-7.289,2.172-3.148-1.84-3.728-5.618-1.48-9.474,2.42-4.135,6.115-5.513,10.083-3.741l-1.036,1.778c-2.945-1.139-5.612-.183-7.463,2.991-1.6,2.737-1.281,5.272.774,6.474,1.445.844,3.115.492,4.842-1.528l2.333-2.651c2.435-2.83,4.966-3.5,7.3-2.134,2.967,1.735,3.509,5.352,1.359,9.031-2.03,3.475-5.323,5.331-8.977,3.773",
    transform: "translate(103.16 146.19)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTc);
export default __webpack_public_path__ + "static/media/logo-tc.9afbb9fc9e88babb28d0d0dddb3abaa7.svg";
export { ForwardRef as ReactComponent };